// extracted by mini-css-extract-plugin
module.exports = {"btnClose":"BtnClose_btnClose__3ZqAI"};